import { composeIO } from 'react-compose-io'
import { cabecalhoIconeExportarRelatorioIO } from './CabecalhoIconeExportarRelatorio.IO'
import { CabecalhoIconeExportarRelatorioView } from './CabecalhoIconeExportarRelatorio.View'

export const CabecalhoIconeExportarRelatorio = composeIO(CabecalhoIconeExportarRelatorioView, cabecalhoIconeExportarRelatorioIO)
